const styles = () => ({
  footer: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
})

export default styles
